export enum AnnouncementTypeEnum{
    Vacancy = 1,
    Training = 2,
    Tender = 3,
    Other = 4
}